import { render, staticRenderFns } from "./DisallowMultiTrioDialog.vue?vue&type=template&id=1cb3d1c3"
import script from "./DisallowMultiTrioDialog.vue?vue&type=script&lang=js"
export * from "./DisallowMultiTrioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports